import { useTranslation } from "react-i18next";

const OfflineUI = () => {
  const { t } = useTranslation();
  const reload = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen w-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900 p-4 transition-colors duration-300">
      <div className="bg-white/90 dark:bg-slate-900/90 backdrop-blur-md border border-slate-200/50 dark:border-slate-800/80 shadow-[0_20px_50px_rgba(0,0,0,0.05)] dark:shadow-[0_20px_50px_rgba(0,0,0,0.3)] rounded-2xl p-8 max-w-md w-full text-center relative overflow-hidden flex flex-col items-center gap-6 transform transition-all duration-300">
        {/* Top decorative accent bar */}
        <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-red-500 via-orange-500 to-amber-500"></div>

        {/* Custom Wifi-Off animated/pulse SVG */}
        <div className="bg-red-50 dark:bg-red-950/30 p-4 rounded-2xl border border-red-100/50 dark:border-red-900/20">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="44" 
            height="44" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            className="text-red-600 dark:text-red-400 animate-pulse"
          >
            <line x1="1" y1="1" x2="23" y2="23"></line>
            <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.5"></path>
            <path d="M5 12.5a10.94 10.94 0 0 1 5.17-2.39"></path>
            <path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path>
            <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path>
            <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
            <line x1="12" y1="20" x2="12.01" y2="20"></line>
          </svg>
        </div>

        {/* Content */}
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-extrabold text-slate-900 dark:text-slate-100 tracking-tight">
            {t('NetworkStatus.OfflineUi')}
          </h1>
          <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed px-2">
            {t('NetworkStatus.OfflineUiMsg')}
          </p>
        </div>

        {/* Interactive reload button */}
        <button 
          onClick={reload} 
          className="group px-6 py-2.5 bg-red-600 hover:bg-red-500 active:bg-red-700 dark:bg-red-500 dark:hover:bg-red-400 dark:active:bg-red-600 text-white font-semibold rounded-xl shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 w-full sm:w-auto"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="18" 
            height="18" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2.2" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            className="transition-transform duration-500 ease-out group-hover:rotate-180"
          >
            <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"/>
          </svg>
          {t('NetworkStatus.Reload')}
        </button>
      </div>
    </div>
  );
};

export default OfflineUI;